import script from "./NewAuthorizationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewAuthorizationPage.vue?vue&type=script&setup=true&lang=js"

import "./NewAuthorizationPage.vue?vue&type=style&index=0&id=f611b48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f611b48c"]])

export default __exports__